import React from "react";
import { FaInstagram, FaYoutube, FaTiktok, FaGlobe, FaArrowRight } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const socialMedia = [
  {
    name: "Instagram",
    username: "@merah.putih08",
    url: "https://www.instagram.com/mera.hputih08",
    icon: FaInstagram,
    color: "from-pink-500 to-orange-400",
  },
  {
    name: "X (Twiter)",
    username: "@MPutih08",
    url: "https://x.com/MPutih08",
    icon: FaXTwitter,
    color: "from-blue-500 to-blue-700",
  },
  {
    name: "YouTube",
    username: "@MerahPutih08",
    url: "https://www.youtube.com/@MerahPutih08-v3f",
    icon: FaYoutube,
    color: "from-red-500 to-red-700",
  },
  {
    name: "TikTok",
    username: "@merahputih08",
    url: "https://www.tiktok.com/@merahputih08.17.10.1951",
    icon: FaTiktok,
    color: "from-black to-gray-700",
  },
  {
    name: "Portal Resmi",
    username: "merahputih08.id",
    url: "https://merahputih08.id",
    icon: FaGlobe,
    color: "from-yellow-500 to-orange-500",
  },
];

export default function SosialMediaMerahPutih08() {
  return (
    <section className="relative overflow-hidden py-20 px-4 md:px-8 font-signika bg-gradient-to-tr from-white via-white to-[#7a0f1e]/30">
      {/* Blur kiri atas */}
      <div className="absolute top-0 left-0 w-[350px] h-[350px] bg-[#7a0f1e]/10 rounded-full blur-[120px]" />

      {/* Blur kanan tengah */}
      <div className="absolute top-1/3 right-0 w-[400px] h-[400px] bg-[#7a0f1e]/8 rounded-full blur-[150px]" />

      {/* Blur bawah tengah */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[500px] h-[250px] bg-[#7a0f1e]/5 rounded-full blur-[150px]" />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* HEADER */}
        <div className="text-center mb-16">
          <div className="relative inline-flex">
            <img src="/images/logo08.png" alt="" className="w-24 h-24" />
          </div>

          <h2 className="mt-6 text-4xl md:text-6xl font-black text-gray-900">
            Ikuti & Hubungi
            <span className="block text-[#7a0f1e]">Merah Putih 08</span>
          </h2>

          <p className="mt-5 max-w-2xl mx-auto text-gray-600 leading-relaxed">Terhubung bersama Merah Putih 08 melalui seluruh kanal resmi media sosial dan portal informasi terpercaya.</p>
        </div>

        {/* SOCIAL CARDS */}
        <div className="grid lg:grid-cols-2 gap-6">
          {socialMedia.map((item, index) => {
            const Icon = item.icon;

            return (
              <a
                key={index}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white border border-gray-200 rounded-3xl p-6 hover:border-[#7a0f1e]/30 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-5">
                    <div
                      className={`w-16 h-16 rounded-2xl bg-gradient-to-r ${item.color}
                      flex items-center justify-center text-white text-2xl shadow-lg`}>
                      <Icon />
                    </div>

                    <div>
                      <h3 className="font-bold text-xl text-gray-900">{item.name}</h3>

                      <p className="text-gray-500">{item.username}</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <span className="hidden md:block text-sm font-semibold text-[#7a0f1e]">Kunjungi</span>

                    <div className="w-10 h-10 rounded-full bg-[#7a0f1e]/10 flex items-center justify-center text-[#7a0f1e] group-hover:bg-[#7a0f1e] group-hover:text-white transition">
                      <FaArrowRight />
                    </div>
                  </div>
                </div>
              </a>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-20">
          <div className="rounded-[40px] bg-gradient-to-r from-[#7a0f1e] to-[#54101a] p-10 md:p-14 text-center overflow-hidden relative">
            <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,white_1px,transparent_1px)] bg-[size:20px_20px]" />

            <div className="relative z-10">
              <h3 className="text-white text-lg md:text-4xl font-black">SHARE • SUBSCRIBE • FOLLOW</h3>

              <p className="text-white/80 mt-4 max-w-2xl mx-auto">Bersama mengawal informasi, memperkuat nasionalisme, dan mendukung Indonesia yang lebih maju.</p>
              {/* 
              <div className="flex flex-wrap justify-center gap-4 mt-8">
                <a href="https://instagram.com" target="_blank" className="bg-white text-[#7a0f1e] px-6 py-3 rounded-full font-bold hover:scale-105 transition">
                  Instagram
                </a>

                <a href="https://facebook.com" target="_blank" className="bg-white text-[#7a0f1e] px-6 py-3 rounded-full font-bold hover:scale-105 transition">
                  Facebook
                </a>

                <a href="https://youtube.com" target="_blank" className="bg-white text-[#7a0f1e] px-6 py-3 rounded-full font-bold hover:scale-105 transition">
                  YouTube
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
